// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const content = "AccomplishmentModal__content__hdj2Q";
export const iconWrapper = "AccomplishmentModal__iconWrapper__FLhe6";
export const icon = "AccomplishmentModal__icon__808ux";
export const title = "AccomplishmentModal__title__4OV8y font-faces__serifMedium__n-4rV font-faces__serif__XseuP";
export const text = "AccomplishmentModal__text__QOQxu font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const buttonWrapper = "AccomplishmentModal__buttonWrapper__60vj+";
export const closeButtonWrapper = "AccomplishmentModal__closeButtonWrapper__WIVvf";